import { useState } from "react";
import styled from "styled-components";
import ImageModal from "./AlMahaDrive/ImageModal";

type Props = {
  linkText: string;
  linkUrl: string;
};

const LinkTextModal = ({ linkText, linkUrl }: Props) => {
  const [openImageModal, setOpenImageModal] = useState(false);

  const handleImageModal = () => {
    setOpenImageModal(true);
  };

  const handleClose = () => {
    setOpenImageModal(false);
  }

  return (
    <>
      <StyledLinkText onClick={handleImageModal}>{linkText}</StyledLinkText>
      <ImageModal onClose={handleClose} open={openImageModal} imageLink={linkUrl} />
    </>
  );
};

const StyledLinkText = styled.button`
  background: transparent;
  border: none;
  color: #2ca5ff;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Poppins-Medium";
  font-weight: 500;
`;

export default LinkTextModal;
